"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFeatureToggle = useFeatureToggle;
const common_components_1 = require("@as-react/common-components");
function useFeatureToggle(flagNames) {
    const { feature_toggles } = (0, common_components_1.useAemConfig)();
    if (Array.isArray(flagNames)) {
        return flagNames.map(name => !!feature_toggles[name]);
    }
    return !!feature_toggles[flagNames];
}
